'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class BankTxController extends FormController {
    /* @ngInject */
    constructor(BankTxesService, ClientsService, EmployeesService,
                $scope, $window, $mdDialog, $mdMenu, $filter) {
        let bankTx = $scope.$parent.$resolve.bankTx;
        super(bankTx, 'Transferencia bancaria', BankTxesService);

        Object.assign(this, {BankTxesService, ClientsService, EmployeesService,
                             $scope, $window, $mdDialog, $mdMenu, $filter});
        this.btnEnabled = true;
    }

    $onInit() {
        super.$onInit();
        this.client = this.model.client;
        this.employee = this.model.employee;
    }

    isApprovable() {
        return (this.model.state == 'draft') &&
            this.model.clientId;
    }

    approve() {
        console.log(this.model);
        this.model.$prototype$approve().then(() => {
            this.model.state = 'approved';
        });
    }

    queryClientSearch() {
        return this.ClientsService.findByName(this.searchClientText);
    }

    selectedClientChange(client) {
        if (client) {
            this.model.clientId = client.id;
            this.client = client;
        }
    }

    queryEmployeeSearch() {
        return this.EmployeesService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchEmployeeText}/i`
                    }
                }
            }
        });
    }

    selectedEmployeeChange(employee) {
        if (employee) {
            this.model.employeeId = employee.id;
            this.employee = employee;
        }
    }
}

export default BankTxController;
